export default __webpack_public_path__ + "static/media/bastian.677201e1.png";